var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":_vm.keepAlive}},[_c('router-view')],1),(_vm.iframeUrl)?_c('iframe',{staticStyle:{"width":"80mm"},attrs:{"src":_vm.iframeUrl,"frameborder":"0","id":"iframe"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }